// extracted by mini-css-extract-plugin
export default {"card_container":"Category_card_container__JMmoN","card":"Category_card__qC19t"};